export enum InstructionTypes  {
    wordpress= 'wordpress',
    elementor = 'elementor',
    wix = 'wix',
    squarespace = 'squarespace',
    webflow = 'webflow',
    weebly = 'weebly',
    godaddy = 'godaddy'
}
